export const calendarRoutes = [
  {
    path: '/selection',
    component: () => import('@/pages/selection/index.vue'),
    meta: {
      layout: 'manse',
    },
  },
  {
    path: '/fortune',
    component: () => import('@/pages/fortune/index.vue'),
    meta: {
      layout: 'manse',
    },
  },
  // 모바일 구 URL은 nginx 미커버 상태라 클라이언트 유지. PC 페이지가 반응형으로 모바일을 흡수했음.
  {
    path: '/mobile/selection',
    redirect: '/selection',
  },
  {
    path: '/mobile/fortune',
    redirect: '/fortune',
  },
  {
    path: '/mobile/calendar/perpetual',
    redirect: '/selection',
  },
  {
    path: '/mobile/calendar/fortune',
    redirect: '/fortune',
  },
];
